import React from 'react'

import { Card, List } from 'antd'
import PT from 'prop-types'
import Box from 'ui-box'

import { hasLength } from '../../../../../../../../../utils/data/utils'

const MembersList = props => {
  const { containerProps, data, EmptyComponent, extra, loading, renderItem, title } = props

  return (
    <Box {...containerProps}>
      <Card
        extra={extra}
        title={
          <h2 style={{ display: 'inline', fontSize: 'inherit', fontWeight: 'inherit', margin: 0 }}>
            {title}
          </h2>
        }
        bodyStyle={{ padding: 0 }}
      >
        {loading || hasLength(data) ? (
          <List loading={loading} dataSource={data} renderItem={item => renderItem({ item })} />
        ) : (
          EmptyComponent
        )}
      </Card>
    </Box>
  )
}

MembersList.propTypes = {
  EmptyComponent: PT.node,
  containerProps: PT.object,
  data: PT.array.isRequired,
  extra: PT.node,
  loading: PT.bool,
  renderItem: PT.func.isRequired,
  title: PT.string.isRequired,
}

export default MembersList
